/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import Dialog from "@atg/icf-react-components/components/Dialog";
import ITheme from "@atg/icf-react-components/themes/Theme";
import { FC, ReactElement } from "react";
import { createUseStyles } from "react-jss";

import { JSS_MEDIA_MOBILE_MAX } from "~/constants";

const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    "& div": {
      "& button": {
        margin: 0,
        minWidth: "132px",
      },
      "& button:first-of-type": {
        // eslint-disable-next-line @atg/css-rtl-support
        margin: `0 ${theme.spacing.base}px 0 0 !important`,
      },
      [JSS_MEDIA_MOBILE_MAX]: {
        display: "flex",
      },
    },
  },
}));

interface Props {
  open: boolean;
  title: string;
  denyLabel?: string;
  confirmLabel: string;
  content: ReactElement | string;
  denyClick?: () => void;
  confirmClick?: () => void;
  enforceOverflow?: boolean;
}

const ConfirmModal: FC<Props> = ({
  open,
  title,
  denyLabel,
  confirmLabel,
  content,
  denyClick,
  confirmClick,
  enforceOverflow = true,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      title={title}
      denyLabel={denyLabel}
      confirmLabel={confirmLabel}
      content={content}
      denyOnClick={denyClick}
      open={open}
      confirmOnClick={confirmClick}
      className={classes.dialog}
      singleAction={!denyLabel}
      data-ta-locator="confirmModal"
      enforceOverflow={enforceOverflow}
    />
  );
};

export default ConfirmModal;
